import React from "react";

import Icon from "../Icon";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import * as testimonialStyles from "./Testimonial.module.css";

const Testimonial = ({ textColor, item }) => {
  const { authorName, authorTitle, testimonial } = item;

  const quoteIcon = {
    name: "fa-quote-left",
    isBrand: false,
    size: "3x",
    color: "seaGreen",
  };

  const starIcon = {
    name: "fa-star",
    isBrand: false,
    size: "xl",
    color: "orange",
  };

  return (
    <div
      className={`${testimonialStyles.testimonial} ${testimonialStyles[textColor]}`}
    >
      <div style={{ position: "relative" }}>
        <div className={testimonialStyles.icon}>
          <Icon props={quoteIcon} />
        </div>
        <h5>{testimonial.testimonial}</h5>
        <div
          className={`${testimonialStyles.iconEnd} ${testimonialStyles.icon}`}
        >
          <Icon props={quoteIcon} />
        </div>
      </div>
      <div className={testimonialStyles.profileContainer}>
        <div>
          <p>
            {authorName}, {authorTitle}
          </p>
          <Icon props={starIcon} />
          <Icon props={starIcon} />
          <Icon props={starIcon} />
          <Icon props={starIcon} />
          <Icon props={starIcon} />
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
